<template>
  <v-container>
    <v-btn :to="`/project/${project.objectId}/board`" color="info" text>{{ $t('back') }}</v-btn>
    <div class="text-xl flex align-center justify-center w-100">
      <v-icon class="mr-2">mdi-newspaper-variant-outline</v-icon>
      {{ $t('project.news_board', {name: project.name}) }}
    </div>
    <div class="text-center mt-5" v-if="isLoading">
      <v-progress-circular :value="20" indeterminate color="success" :size="50" :width="5"></v-progress-circular>
    </div>
    <v-card class="mx-auto mt-12 mb-4" max-width="800" :loading="isLoading" v-if="!isLoading">
      <v-card-text v-if="post" style="padding:0;">
        <div class="flex p-4">
          <div class="px-0 pt-0 flex name-box align-center">
            <v-icon>mdi-account-circle</v-icon>
            <div style="max-width:calc(100% - 50px);">
              <div class="text-fullname">
                {{ post.createdFullName }}
                <v-chip
                  v-if="post.admin"
                  color="rgb(209,242,225)"
                  small 
                  class="green--text"
                  style="transform: scale(.9)"
                >
                  {{ $t('project.admin') }}
                </v-chip>
                <v-chip 
                  v-if="post.employees && post.employees.length"
                  color="rgb(209,242,225)"
                  small 
                  class="green--text"
                  style="transform: scale(.9)"
                >
                  {{ $t('project.employee') }}
                </v-chip>
              </div>
              <div class="text-position">
                <span>{{ $t('project.post_at', {post: post.createdAtFormat}) }}</span>
              </div>
            </div>
          </div>
          <div class="px-0 pt-0 name-box text-right">
            <v-menu>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on">
                  <v-icon small>mdi-chevron-down-box-outline</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="isConfirmRemove = true " :disabled="isLoading">
                  <v-icon class="mr-2">mdi-trash-can-outline</v-icon>{{ $t('project.delete_post') }}
                </v-list-item>
              </v-list>
            </v-menu>
            <PostPrivacyTooltip :post="post"></PostPrivacyTooltip>
          </div>
        </div>
        <div class="title-text" v-if="post.title">{{post.title}}</div>
        <div class="preview-text" v-if="post.preview">{{post.preview}}</div>
        <template v-if="post.images && post.images.length">
          <v-divider></v-divider>
          <div class="row-image">
            <div :class="`col-image ${post.images.length == 1 ? 'col-image-1' : ''}`" v-for="(image, index) in post.images" :key="index">
              <v-skeleton-loader
                class="m-0 load-image-post"
                type="image"
                height="300px"
                min-height="300px"
                width="100%"
                v-if="isLoadImagePost[index]"
              ></v-skeleton-loader>
              <img
                v-show="!isLoadImagePost[index]"
                class="image-post"
                :src="image.url"
                @load="loadImagePost(index)"
                @click="showImages = true;slideIndex = index"
                :id="`image-post-in-${index}`"
              />
            </div>
          </div>
        </template>
        <v-divider></v-divider>
        <div class="text-right p-1 px-4" style="font-size:13px;">
          <v-icon small>mdi-eye</v-icon>
          {{ $t('project.seen_post', {count: post.seenCount || 0}) }}
        </div>
      </v-card-text>
    </v-card>
    <v-card class="mx-auto" max-width="800" :loading="isLoading" v-if="!isLoading">
      <v-card-text>
        <v-card elevation="0" v-for="comment in comments" :key="comment.objectId">
          <v-card-text class="py-0">
            <v-icon
              large
              left
            >
              mdi-account-circle
            </v-icon>
            <div style="display: inline; position: relative; top: -10px;">
              <span>
                <b class="">{{ `${comment.createdBy.firstName} ${comment.createdBy.lastName} ` }} 

                  <!-- <small v-if="comment.admin">ผู้ดูแล </small>
                  <small v-if="comment.employees && comment.employees.length">พนักงาน </small> -->
                </b>
              </span>
              <small> {{ $moment(comment.createdAt).format("DD/MM/YYYY, HH:mm " + $t('timeunit.minute.short')) }}</small>
              <br>
            </div>
            <div class="ps-9" style="position: relative; top: -20px;">
              <v-chip
                v-if="comment.admin"
                color="rgb(209,242,225)"
                small 
                class="green--text"
                style="transform: scale(.9)"
              >
                {{ $t('project.admin') }}
              </v-chip>
              <v-chip 
                v-if="comment.employees && comment.employees.length"
                color="rgb(209,242,225)"
                small 
                class="green--text"
                style="transform: scale(.9)"
              >
                {{ $t('project.employee') }}
              </v-chip>
              <template v-if="comment.contracts && comment.contracts.length">
                <v-chip 
                  v-for="contract in comment.contracts"
                  :key="contract.objectId"
                  small
                  style="transform: scale(.9)"
                >
                  <b class="me-2">{{ contract.market.name }}</b> {{ contract.areas.map(d => d.name).join(",") }}
                </v-chip>
              </template>

            </div>
            <div class="ps-11" style="margin-top: -15px">
              <p>{{ comment.message }}</p>
            </div>
          </v-card-text>
        </v-card>
        <div class="text-center" v-if="post.disableComment">
          <v-icon small>mdi-close-circle-outline</v-icon>
          {{ $t('project.post_close_comment') }}
        </div>
        <v-card elevation="0" class="px-5" v-if="!post.disableComment">
          <v-text-field
            v-model="formData.message"
            append-outer-icon="mdi-send"
            prepend-icon="mdi-account-circle"
            :placeholder="$t('project.comment_here')"
            type="text"
            @click:append-outer="onComment()"
          ></v-text-field>
        </v-card>
      </v-card-text>
    </v-card>
    <v-dialog v-model="showImages" max-width="90%" scrollable>
      <v-card width="100%" height="100%" outlined>
        <v-card-title color="white" class="flex justify-space-between shadow">
          <div>{{ $t('project.image_post') }}</div>
          <v-btn class="close-icon" icon @click="showImages = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-carousel
            v-if="post && post.images && post.images.length"
            show-arrows-on-hover
            hide-delimiter-background
            v-model="slideIndex"
            height="75vh"
          >
            <v-carousel-item v-for="(image, index) in post.images" :key="index">
              <img
                class="image-carousel-post"
                :src="image.url"
                @load="loadImagePost(index)"
                :id="`image-post-carousel-in-${index}`"
              />
            </v-carousel-item>
          </v-carousel>
        </v-card-text>
      </v-card>
    </v-dialog>
    <ConfirmDialog
      :title="$t('project.confirm_delete_post')"
      :description="this.$t('validate.want_delete_post')"
      @onOk="removedPost(post.objectId)"
      :confirmColor="`error`"
      v-model="isConfirmRemove"
    ></ConfirmDialog>
  </v-container>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import ConfirmDialog from "../../components/ConfirmDialog.vue";
import PostPrivacyTooltip from "../../components/PostPrivacyTooltip.vue";
export default {
  components: {
    ConfirmDialog,
    PostPrivacyTooltip
  },
  data() {
    return {
      projectId: this.$route.params.projectId,
      postId: this.$route.params.postId,
      isLoadImagePost: [],
      canSeeLabel: [
        {
          value: "public",
          text: this.$t('project.see_all_market'),
          note: this.$t('project.all_market_in_project'),
          icon: "mdi-earth"
        },
        {
          value: "private",
          text: this.$t('project.see_only_market'),
          note: this.$t('project.select_post_market_only'),
          icon: "mdi-account-group"
        }
      ],
      privacyLabel: {
        public: 1,
        private: 2
      },
      showImages: false,
      slideIndex: 0,
      isLoading: false,
      isConfirmRemove: false,
      formData: {
        message: ""
      }
    };
  },
  computed: {
    ...mapGetters({
      post: "post/getPost",
      seenPostUser: "post/getSeenPostUser"
    }),
    ...mapState({
      comments: (state) => state.comment.comments,
    }),
    admins() {
      return this.$store.getters["admin/getByProjectId"](this.projectId);
    },
    employees() {
      return this.$store.getters["employee/getByProjectId"](this.projectId);
    },
    project() {
      let project;
      if (this.admins && this.admins.length > 0)
        project = this.admins[0].project;
      if (!project && this.employees && this.employees.length > 0)
        project = this.employees[0].project;
      return project;
    },
    sessionObjectId(){
      let adminId;
      let employeeIds;
      if(this.admins && this.admins.length){
        adminId = this.admins[0].objectId
      }else if(this.employees && this.employees.length){
        employeeIds = this.employees.map(d => d.objectId)
      }
      return {
        adminId,
        employeeIds
      }
    }
  },
  created() {
    if (
      !(
        (this.admins && this.admins.length) ||
        (this.employees && this.employees.find(d => d.enableViewBoard))
      )
    ) {
      this.$router.push(`/notFound`);
    }
    this.getPost();
  },
  mounted() {
    this.setProjectId(this.projectId);
  },
  methods: {
    setProjectId(projectId) {
      this.$store.commit("markets/setProjectId", {
        projectId: projectId
      });
    },
    async getPost() {
      this.isLoadImagePost = [];
      try {
        this.isLoading = true;
        await this.$store.dispatch("post/getPost", this.postId);
        await this.loadComment()
        // this.$store.dispatch("post/getSeenPostUser", this.postId);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log({ error });
        this.$toast.show({
          content: `${this.$t('project.cannot_load_post')} Error : ${error.response.statusText}`,
          color: "error"
        });
      }
      if (this.post) {
        if (this.post.images && this.post.images.length)
          for (const image of this.post.images) {
            this.isLoadImagePost.push(true);
          }
      } else {
        this.$router.push(`/project/${this.project.objectId}/board`);
      }
    },
    async removedPost(postObjectId) {
      this.isConfirmRemove = false;
      this.isLoading = true;
      await this.$store.dispatch("post/removedPost", postObjectId);
      this.isLoading = false;
      this.$router.push(`/project/${this.project.objectId}/board`);
    },
    loadImagePost(index) {
      this.isLoadImagePost[index] = false;
      this.$forceUpdate();
    },
    async loadComment(){
      await this.$store.dispatch("comment/getCommentByPost", {
        postId: this.post.objectId,
      });
    },
    async onComment(){
      this.isLoading = true
      try{
        await this.$store.dispatch("comment/createComment", {
          postId: this.post.objectId,
          message: this.formData.message,
          ...this.sessionObjectId
        });
        await this.loadComment()
        this.formData.message = ""
        this.isLoading = false 
      }catch(err){
        this.isLoading = false 
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.title-text{
  margin: 20px;
  margin-top: 15px;
  font-size: 18px;
  font-weight: bold;
  text-indent: 15px;
}
.preview-text{
  margin: 20px;
  text-indent: 15px;
}
.name-box {
  .v-icon {
    font-size: 40px;
    margin-right: 5px;
  }
  .text-fullname {
    font-size: 18px;
  }
  .text-position {
    font-size: 15px;
    line-height: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    .v-icon {
      font-size: 12px;
    }
    span {
      font-size: 12px;
    }
  }
}
.row-image {
  display: flex;
  flex-wrap: wrap;
  flex: 1 1 auto;
  margin: 0px;
  padding: 0px;
  justify-content: center;
  .col-image {
    flex: 0 0 50%;
    max-width: 50%;
    max-height: 300px;
    width: 100%;
    padding: 0;
  }
  .col-image-1 {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
.load-image-post {
  margin: 0 !important;
}
.load-image-post::v-deep .v-skeleton-loader__image {
  height: 300px;
}
img.image-post {
  height: 300px;
  // height: 100%;
  width: 100%;
  object-fit: cover;
  // border-radius: 5px;
}
img.image-carousel-post {
  height: 100%;
  width: 100%;
  object-fit: contain;
}
</style>